<ng-http-loader [backdrop]="true" [backgroundColor]="'#ff0000'" [backdropBackgroundColor]="'#ffffff'" [opacity]="0.3"
   [spinner]="spinkit.skThreeBounce">
</ng-http-loader>
<div class="main-content">
   <div class="container">
      <div class="row justify-content-end" style="margin-top: 2%;">
         <div class="col-md-12 offset-md-4">
            <div class="row">
               <div class="col-md-3">
                  <tc-form-group>
                     <tc-switcher *ngIf="restaurant_online_status  != 'Active' " [value]="false" #templateForm
                        (click)="restaurantOrderStatusResto('Active')" style="color:green"> Accept takeaway orders
                     </tc-switcher>
                     <tc-switcher *ngIf="restaurant_online_status  === 'Active'" [value]="true" #templateForm
                        (click)="restaurantOrderStatusResto('Inactive')" style="color:green"> Accept takeaway orders
                     </tc-switcher>
                  </tc-form-group>
               </div>
               <div class="col-md-3">
                  <tc-form-group>
                     <tc-switcher *ngIf="serviceableStatus != 'Active'" [value]="false" #templateForm
                        (click)=" updateDeliveryStatus('Active')" style="color:green"> Restaurant is serviceable
                     </tc-switcher>
                     <tc-switcher *ngIf="serviceableStatus === 'Active'" [value]="true" #templateForm
                        (click)=" updateDeliveryStatus('Inactive')" style="color:green"> Restaurant is serviceable
                     </tc-switcher>
                  </tc-form-group>
               </div>
               <div class="col-md-3">
                  <tc-form-group>
                     <tc-switcher *ngIf="nutri_info_value  != 'Active' " [value]="false" #templateForm
                        (click)="nutri_info('Active')" style="color:green">Display nutritional information</tc-switcher>
                     <tc-switcher *ngIf="nutri_info_value  === 'Active'" [value]="true" #templateForm
                        (click)="nutri_info('Inactive')" style="color:green">Display nutritional information
                     </tc-switcher>
                  </tc-form-group>
               </div>

               <div class="col-md-3">
                  <tc-form-group>
                     <button class="button-btn" (click)="Onclickbutton()">
                        <tc-icon [iconClass]="'icofont-ui-home'" [tcFontSize]="22" [tcColor]="['#fffff', '#fffff']"
                           title="Back to Home" style="margin-top: -5px !important;"></tc-icon>
                        Back To Home
                     </button>
                  </tc-form-group>
               </div>
               <div class="col-md-3">
                  <tc-form-group>
                     <tc-switcher *ngIf="hide_spice_tollrance  == '0' " [value]="false" #templateForm
                        (click)="updateSpiceTollerance(1)" style="color:green">Hide Spice Tolerance</tc-switcher>
                     <tc-switcher *ngIf="hide_spice_tollrance  == '1'" [value]="true" #templateForm
                        (click)="updateSpiceTollerance(0)" style="color:green">Hide Spice Tolerance
                     </tc-switcher>
                  </tc-form-group>
               </div>
            </div>
         </div>
      </div>
   </div>
   <div class="container">
      <div class="row">
         <div class="col-12 col-md-6">
            <tc-card>
               <tc-form-group>
                  <div class="row align-items-center">
                     <div class="col-12 col-md-4">
                        <tc-form-label class="mb-md-0">Restaurant name</tc-form-label>
                     </div>
                     <div class="col-12 col-md-8">
                        <tc-input [(ngModel)]="rstoName">{{rstoName}}</tc-input>
                     </div>
                  </div>
               </tc-form-group>
               <tc-form-group>
                  <div class="row align-items-center">
                     <div class="col-12 col-md-4">
                        <tc-form-label class="mb-md-0">Spice tolerance level</tc-form-label>
                     </div>
                     <div class="col-12 col-md-8">
                        <tc-select [placeholder]="'Spice tolerance level'" [options]="data"
                           [(ngModel)]="spice_tollerence_level">{{spice_tollerence_level}}</tc-select>
                     </div>
                  </div>
               </tc-form-group>
               <tc-form-group>
                  <div class="row align-items-center">
                     <div class="col-12 col-md-4">
                        <tc-form-label class="mb-md-0">Restaurant telephone</tc-form-label>
                     </div>
                     <div class="col-12 col-md-8">
                        <tc-input [placeholder]="'Restaurant telephone'" [(ngModel)]="telephone">{{telephone}}
                        </tc-input>
                     </div>
                  </div>
               </tc-form-group>
               <tc-form-group>
                  <div class="row align-items-center">
                     <div class="col-12 col-md-4">
                        <tc-form-label class="mb-md-0">Restaurant address</tc-form-label>
                     </div>
                     <div class="col-12 col-md-8">
                        <tc-textarea [placeholder]="'Restaurant address'" [(ngModel)]="rstoAdd">{{rstoAdd}}
                        </tc-textarea>
                     </div>
                  </div>
               </tc-form-group>
               <tc-form-group>
                  <div class="row align-items-center">
                     <div class="col-12 col-md-4">
                        <tc-form-label class="mb-md-0">Service charge(%)</tc-form-label>
                     </div>
                     <div class="col-12 col-md-8">
                        <!-- <tc-input [placeholder]="'Service charge'" type="number" step="1"  min="1"
                        onkeydown="return event.keyCode !== 69 && event.keyCode !== 189" [(ngModel)]="servicecharge">
                        </tc-input> -->
                        <input [placeholder]="'Service charge'" class="text_add" type="number" step="1" min="0"
                           onkeydown="return event.keyCode !== 69 && event.keyCode !== 189" [(ngModel)]="servicecharge">
                        <div *ngIf="errortext == '1'">
                           <span style="color: red !important;">Please enter valid number</span>
                        </div>
                     </div>
                  </div>
               </tc-form-group>
               <tc-form-group>
                  <div class="row align-items-center">
                     <div class="col-12 col-md-4">
                        <tc-form-label class="mb-md-0">Allergen Message</tc-form-label>
                     </div>
                     <div class="col-12 col-md-8">
                        <tc-textarea [placeholder]="'Allergen Message'"
                           [(ngModel)]="rstoAllergenMsg">{{rstoAllergenMsg}}
                        </tc-textarea>
                     </div>
                  </div>
               </tc-form-group>
            </tc-card>
         </div>
         <div class="col-12 col-md-6">
            <tc-card>
               <tc-form-group>
                  <div class="row align-items-center">
                     <div class="col-12 col-md-4">
                        <tc-form-label class="mb-md-0">POC name</tc-form-label>
                     </div>
                     <div class="col-12 col-md-8">
                        <tc-input [placeholder]="'POC name'" [(ngModel)]="rstopocName">{{rstopocName}}</tc-input>
                     </div>
                  </div>
               </tc-form-group>
               <tc-form-group>
                  <div class="row align-items-center">
                     <div class="col-12 col-md-4">
                        <tc-form-label class="mb-md-0">POC id</tc-form-label>
                     </div>
                     <div class="col-12 col-md-8">
                        <tc-input [placeholder]="'POC id'" [(ngModel)]="pocID ">{{pocID }}</tc-input>
                     </div>
                  </div>
               </tc-form-group>
               <tc-form-group>
                  <div class="row align-items-center">
                     <div class="col-12 col-md-4">
                        <tc-form-label class="mb-md-0">No of tables</tc-form-label>
                     </div>
                     <div class="col-12 col-md-8">
                        <tc-input [placeholder]="'Number of tables'" [(ngModel)]="table ">{{table}}</tc-input>
                     </div>
                  </div>
               </tc-form-group>
               <tc-form-group>
                  <div class="row align-items-center" style="margin-top: -10px;">
                     <div class="col-12 col-md-4">
                        <tc-form-label class="mb-md-0">Offer discount</tc-form-label>
                     </div>
                     <div class="col-12 col-md-8">
                        <br>
                        <tc-form-group>
                           <tc-switcher *ngIf="restaurant_coupan_status  != 'Active' " [value]="false" #templateForm
                              (click)="restaurant_coupan('Active')" style="color:green">
                           </tc-switcher>
                           <tc-switcher *ngIf="restaurant_coupan_status  === 'Active'" [value]="true" #templateForm
                              (click)="restaurant_coupan('Inactive')" style="color:green">
                           </tc-switcher>
                        </tc-form-group>
                     </div>
                  </div>
               </tc-form-group>
               <tc-form-group>
                  <div class="row align-items-center " style="margin-top: -20px;">
                     <div class="col-12 col-md-4">
                        <tc-form-label class="mb-md-0">Offer value(%)</tc-form-label>
                     </div>
                     <div class="col-12 col-md-8">

                        <ng-container *ngIf="restaurant_coupan_status =='Active'">
                           <!-- <tc-input  [placeholder]="'Restaurant coupan value'"  [(ngModel)]="restaurant_coupan_value">{{restaurant_coupan_value}}</tc-input> -->
                           <!-- <tc-input [placeholder]="'Offer value'" type="number" step="1"  min="1"
                           onkeydown="return event.keyCode !== 69 && event.keyCode !== 189" [(ngModel)]="restaurant_coupan_value">{{restaurant_coupan_value}}
                           </tc-input> -->

                           <input class="text_add" [placeholder]="'Offer value'" type="number" step="1" min="0"
                              onkeydown="return event.keyCode !== 69 && event.keyCode !== 189"
                              [(ngModel)]="restaurant_coupan_value" type="number">
                        </ng-container>
                        <ng-container *ngIf="restaurant_coupan_status !='Active'">
                           <tc-input [placeholder]="'Restaurant coupan value'" [readonly]=true
                              [(ngModel)]="restaurant_coupan_value">{{restaurant_coupan_value}}</tc-input>
                        </ng-container>
                     </div>
                  </div>
               </tc-form-group>

               <tc-form-group>
                  <div class="row align-items-center ">
                     <div class="col-12 col-md-4">
                        <tc-form-label class="mb-md-0">Restaurant waiting time
                           <br>(Hour : Minute)</tc-form-label>
                     </div>
                     <div class="col-12 col-md-8">
                        <input [ngxTimepicker]="picker" [format]="24" [value]="restaurant_wt" class="picker_time">
                        <ngx-material-timepicker #picker (timeSet)="setTime($event)"></ngx-material-timepicker>
                     </div>
                  </div>
               </tc-form-group>
               
            </tc-card>
         </div>
         <div class="col-md-12" *ngIf="restaurant_coupan_status =='Inactive'">
            <div class="wrapper" align="center">
               <button class="button"
                  (click)="Onupdate(rstoName,rstoAdd,rstopocName,pocID,spice_tollerence_level,table,telephone,servicecharge, rstoAllergenMsg)">Update
                  Details </button>
            </div>
         </div>
         <div class="col-md-12" *ngIf="restaurant_coupan_status =='Active'">
            <div class="wrapper" align="center">
               <button class="button"
                  (click)="Onupdate_resto(rstoName,rstoAdd,rstopocName,pocID,spice_tollerence_level,table,telephone,servicecharge,restaurant_coupan_value,rstoAllergenMsg)">Update
                  Details </button>
            </div>
         </div>
      </div>
   </div>

   <div class="container">
      <div class="row">
         <div class="col-12">
            <span class="titles">Choose your allergens</span>
         </div>
         <div class="row button-group round toggle padlr5">
            <ng-container *ngIf="status_active_none_allergens_active">
               <div class="col-2 padlr5">
                  <input type="checkbox" [checked]="true" id="r2" name="r-group">
                  <label class="btns" for="r2" (click)="AllergensRemove()">None</label>
               </div>
            </ng-container>
            <ng-container *ngIf="status_active_none_allergens_inactive">
               <div class="col-2 padlr5">
                  <input type="checkbox" [checked]="false" id="r2" name="r-group">
                  <label class="btns" for="r2" (click)="AllergensRemove()">None</label>
               </div>
            </ng-container>
            <div class="col-2 padlr5" *ngFor="let item of allergens; index as i">
               <ng-container *ngIf="(item.isSelected == 'Yes'? true:false)">
                  <input type="checkbox" [checked]="true" [id]="item.allergens_name" name="r-group">
                  <label class="btns" [title]="item.allergens_name" [for]="item.allergens_name"
                     (click)="toggleSelectedAllergence(item.allergens_id,item.allergens_name,i);inactiveAllegens(item.allergens_id,item.allergens_name,i);setAllergenceActiveClass()">{{item.allergens_name}}
                  </label>
               </ng-container>
               <ng-container *ngIf="(item.isSelected == 'No'? true:false)">
                  <input type="checkbox" [checked]="false" [id]="item.allergens_name" name="r-group">
                  <label class="btns" [title]="item.allergens_name" [for]="item.allergens_name"
                     (click)="toggleSelectedAllergence(item.allergens_id,item.allergens_name,i);setAllergenceActiveClass()">{{item.allergens_name}}</label>
               </ng-container>
            </div>
         </div>
         <div class="col-12">
            <span class="titles">Choose dietary preference</span>
         </div>
         <div class="row button-group round toggle padlr5">
            <ng-container *ngIf="status_active_dietary">
               <div class="col-2  padlr5">
                  <input type="checkbox" [checked]="true" id="r1" name="r-group">
                  <label class="btns" for="r1" (click)="dietRemove()">None</label>
               </div>
            </ng-container>
            <ng-container *ngIf="status_inactive_dietary">
               <div class="col-2  padlr5">
                  <input type="checkbox" [checked]="false" id="r1" name="r-group">
                  <label class="btns" for="r1" (click)="dietRemove()">None</label>
               </div>
            </ng-container>
            <div class="col-2  padlr5" *ngFor="let item of allDiestpref; index as i">
               <ng-container *ngIf="(item.isSelected == 'Yes'? true:false)">
                  <input type="checkbox" [checked]="true" [id]="item.diet_preference_name" name="r-group">
                  <label class="btns" [title]="item.diet_preference_name" [for]="item.diet_preference_name"
                     (click)="addAllDiet(item.diet_preference_id,item.diet_preference_name,i);inactiveDietary(item.diet_preference_id,item.diet_preference_name,i);setActiveClass()">{{item.diet_preference_name}}</label>
               </ng-container>
               <ng-container *ngIf="(item.isSelected == 'No'? true:false)">
                  <input type="checkbox" [checked]="false" [id]="item.diet_preference_name" name="r-group">
                  <label class="btns" [title]="item.diet_preference_name" [for]="item.diet_preference_name"
                     (click)="addAllDiet(item.diet_preference_id,item.diet_preference_name,i);setActiveClass()">{{item.diet_preference_name}}</label>
               </ng-container>
            </div>
         </div>
      </div>
   </div>
</div>